// frontend/src/components/loi/enterNeverFiles.ts
import type { KeyboardEvent } from 'react';

/** Inputs that Enter PRESSES, the way it presses a button - pressing is not the implicit submission refused below. */
const PRESSED = new Set(['button', 'submit', 'reset', 'image']);

/**
 * ⛔⛔ ENTER NEVER FILES THE LETTER - ONLY GENERATE DOES (his answer 2026-09-30, the 113th). Enter on an input inside a
 *    form submits it, and the letter's form submits to Generate, which FILES the letter on a deal: a stray Enter while
 *    typing a buyer's name did, and so did Enter on a checkbox (I1, found in the Change box). So on an input Enter does
 *    nothing; a textarea still takes its new line and a button is still pressed, neither being implicit submission.
 * ⭐ ONE rule, attached ONCE, on the letter's form: every box inside it - the Change box included, whose own copy of
 *   this rule was retired when a sabotage showed the form's already covered it - sends its Enter up through the form.
 *   A box with an Enter of its own (the what-if's "Price it") still acts first: this only stops the submit it causes.
 */
export const enterNeverFiles = (e: KeyboardEvent<HTMLElement>): void => {
  const t = e.target;
  if (e.key === 'Enter' && t instanceof HTMLInputElement && !PRESSED.has(t.type)) e.preventDefault();
};
